// @ts-nocheck
// fetch all coordinators
export const FETCH_ALL_COORDINATOR_REQUEST = "FETCH_ALL_COORDINATOR_REQUEST";
export const FETCH_ALL_COORDINATOR_SUCCESS = "FETCH_ALL_COORDINATOR_SUCCESS";
export const FETCH_ALL_COORDINATOR_FAILURE = "FETCH_ALL_COORDINATOR_FAILURE";

// create a coordinator
export const CREATE_COORDINATOR_REQUEST = "CREATE_COORDINATOR_REQUEST";
export const CREATE_COORDINATOR_SUCCESS = "CREATE_COORDINATOR_SUCCESS";
export const CREATE_COORDINATOR_FAILURE = "CREATE_COORDINATOR_FAILURE";

// update a coordinator
export const UPDATE_COORDINATOR_REQUEST = "UPDATE_COORDINATOR_REQUEST";
export const UPDATE_COORDINATOR_SUCCESS = "UPDATE_COORDINATOR_SUCCESS";
export const UPDATE_COORDINATOR_FAILURE = "UPDATE_COORDINATOR_FAILURE";

// delete a coordinator
export const DELETE_COORDINATOR_REQUEST = "DELETE_COORDINATOR_REQUEST";
export const DELETE_COORDINATOR_SUCCESS = "DELETE_COORDINATOR_SUCCESS";
export const DELETE_COORDINATOR_FAILURE = "DELETE_COORDINATOR_FAILURE";

// toggle coordinator status
export const TOGGLE_COORDINATOR_STATUS_REQUEST =
  "TOGGLE_COORDINATOR_STATUS_REQUEST";
export const TOGGLE_COORDINATOR_STATUS_SUCCESS =
  "TOGGLE_COORDINATOR_STATUS_SUCCESS";
export const TOGGLE_COORDINATOR_STATUS_FAILURE =
  "TOGGLE_COORDINATOR_STATUS_FAILURE";

// search coordinator
export const SEARCH_COORDINATOR_REQUEST = "SEARCH_COORDINATOR_REQUEST";
export const SEARCH_COORDINATOR_SUCCESS = "SEARCH_COORDINATOR_SUCCESS";
export const SEARCH_COORDINATOR_FAILURE = "SEARCH_COORDINATOR_FAILURE";